import { AccountState, TerminationReason } from '../account/account';
import {
  AccountIdentifier,
  BaseIdentifiers,
  UserIdentifier,
} from '../common/identifiers';

export type AccountEvent = BaseIdentifiers &
  UserIdentifier &
  AccountIdentifier & {
    event: AccountEventItem;
    metadata?: AccountEventMetadata;
  };

export enum AccountEventItem {
  Created = 'created',
  Delete = 'delete',
  DailyPause = 'daily-pause',
  ResetDailyPause = 'reset-daily-pause',
  DailyLoss = 'daily-loss',
  Termination = 'termination',
  WithdrawRequested = 'withdraw-requested',
  Target = 'target',
  Expired = 'expired',
  ManualEnable = 'enable',
  ManualDisable = 'disable',
  BypassDailyPause = 'bypass-daily-pause',
  ExpirationExtend = 'expiration-extended',
  InactivityDays = 'inactivity-days',
  MaxLossTargetReached = 'max-loss-target-reached',
}

export type AccountEventMetadata = {
  eventByUserId: string;
  eventByUserEmail?: string;
  state?: AccountState;
  prevState?: AccountState;
  terminationReason?: TerminationReason;
};
